import { getProductIcon } from 'legoland-sdk';
import { TomTomIcon } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductLogo = ({
  productId,
  ...svgProps
}) => {
  const Icon = productId === 'move' ? TomTomIcon : getProductIcon(productId);
  return /*#__PURE__*/_jsx(Icon, {
    ...svgProps,
    "data-sentry-element": "Icon",
    "data-sentry-component": "ProductLogo",
    "data-sentry-source-file": "ProductLogo.tsx"
  });
};